function parseURI(value) {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch (ex) {
    return '';
  }
}

export function SplitQueryString(inputQueryString) {
  const queryString = inputQueryString || window.location.search;
  if (!queryString) return {};

  const items = {};
  return (/^[?#]/.test(queryString) ? queryString.slice(1) : queryString)
    .split('&')
    .reduce((params, param) => {
      const [key, value] = param.split('=');
      items[key] = !value ? '' : parseURI(value);
      return items;
    }, { });
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/QueryString/QueryString.js